export default {
    books: [
        {
            id: self.index,
            name: "Bad Science",
            author: "Ben Goldacre",
            cover: "badscience.jpg",
            date: "June 20th, 2020",
            title: "The Fragility of Fact",
            content: "badscience.md"
        },
        {
            id: self.index,
            name: "Prisoners of Geography",
            author: "Tim Marshall",
            cover: "prisonersofgeography.png",
            date: "June 4th, 2020",
            title: "Winning By Default: The American Story",
            content: "comingsoon.md"
        },
        {
            id: self.index,
            name: "The Righteous Mind",
            cover: "therighteousmind.png",
            author: "Jonathan Haidt",
            date: "May 5th, 2020",
            title: "The Purpose of Morals",
            content: "comingsoon.md"
        },
        {
            id: self.index,
            name: "Winners Take All",
            cover: "winnerstakeall.png",
            author: "Anand Giridharadas",
            date: "May 21st, 2020",
            title: "The Limit of Philanthropy",
            content: "comingsoon.md"
        },
        {
            id: self.index,
            name: "The Color of Law",
            cover: "coloroflaw.jpg",
            author: "Richard Rothstein",
            date: "October 7th, 2020",
            title: "White",
            content: "coloroflaw.md"
        }
    ]
}